const COLOURS = [
    '#99D8E3',
    '#BC40FF',
    '#92E996',
    '#32C8D5',
    '#24D95E',
    '#136789',
    '#50E0A7',
    '#FA4554',
    '#E7D180',
    '#970567',
    '#075846',
    '#38539F',
    '#266973',
    '#6DA7B8',
    '#31142C',
    '#035383',
    '#DA09F7',
    '#4C1FCD',
    '#780A3D',
    '#08A5F8',
    '#0474DE',
    '#B34970',
    '#B34970',
    '#0187D5',
    '#A9DDEE',
    '#D53D78',
]

export function getColour(fullName = '') {
    if (!fullName) return COLOURS[0]
    return COLOURS[fullName[0].toLowerCase().charCodeAt(0) - 97]
}
